import { Injectable } from "@angular/core";
import { Environment } from "@environments";

@Injectable({ providedIn: 'root' })
export class SettingsManager
{
  private _minPasswordLength: number = 12;
  private _maxPasswordLength: number = 120;
  private _minAcceptablePasswordStrength: number = 3;
  private _isChatIconEnabled: boolean = false;
  private _isAivoChatbotEnabled: boolean = false;
  private _isWhatsAppIconEnabled: boolean = false;
  private _qualtricsSurveySamplingShoppingCart: number = 0;

  private _maxItems: number = 300;
  private _isCreditCardGenericDomainEnabled: boolean = false;
  private _isMaintenance = Environment.isMaintenance;

  constructor() { }
  // ********************************************************************
  // #region Min Acceptable Password Strength
  // ********************************************************************
  public set setMinAcceptablePasswordStrength(value: number)
  {
    this._minAcceptablePasswordStrength = value;
  }

  public get minAcceptablePasswordStrength(): number
  {
    return this._minAcceptablePasswordStrength;
  }

  // ********************************************************************
  // #endregion Min Acceptable Password Strength
  // ********************************************************************

  // ********************************************************************
  // #region Min Password Length
  // ********************************************************************
  public set setMinPasswordLength(value: number)
  {
    this._minPasswordLength = value;
  }

  public get minPasswordLength(): number
  {
    return this._minPasswordLength;
  }

  // ********************************************************************
  // #endregion Min Password Length
  // ********************************************************************

  // ********************************************************************
  // #region Max Password Length
  // ********************************************************************
  public set setMaxPasswordLength(value: number)
  {
    this._maxPasswordLength = value;
  }

  public get maxPasswordLength(): number
  {
    return this._maxPasswordLength;
  }

  // ********************************************************************
  // #endregion Max Password Length
  // ********************************************************************

  // ********************************************************************
  // #region ChatIconEnabled
  // ********************************************************************

  public set setChatIconEnabled(value: boolean)
  {
    this._isChatIconEnabled = value;
  }

  public get isChatIconEnabled(): boolean
  {
    return this._isChatIconEnabled;
  }

  public set setCreditCardGenericDomainEnabled(value: boolean)
  {
    this._isCreditCardGenericDomainEnabled = value;
  }

  public get isCreditCardGenericDomainEnabled(): boolean
  {
    return this._isCreditCardGenericDomainEnabled;
  }

  public set setWhatsappIconEnabled(value: boolean)
  {
    this._isWhatsAppIconEnabled = value;
  }

  public get isWhatsAppIconEnabled(): boolean
  {
    return this._isWhatsAppIconEnabled;
  }

  public set setIsAivoChatbotEnabled(value: boolean)
  {
    this._isAivoChatbotEnabled = value;
  }

  public get isAivoChatbotEnabled(): boolean
  {
    return this._isAivoChatbotEnabled;
  }

  public set setItemsLimit(value: number)
  {
    this._maxItems = value;
  }

  public get itemsLimit(): number
  {
    return this._maxItems;
  }

  public set setMaintenance(value: boolean)
  {
    this._isMaintenance = value;
  }

  public get isMaintenance(): boolean
  {
    return this._isMaintenance;
  }

  public set setQualtricsSurveySamplingShoppingCart(value: number)
  {
    this._qualtricsSurveySamplingShoppingCart = value;
  }

  public get qualtricsSurveySamplingShoppingCart(): number
  {
    return this._qualtricsSurveySamplingShoppingCart;
  }
}
